import React from 'react';
import { DefaultTooltipContent } from 'recharts/lib/component/DefaultTooltipContent';
import { unixToFormattedDate } from '../../../utils/date-utils';
import { generateStabilizationLabel } from './asin_metrics_utils';

const CustomTooltipContent = (props) => {
  if (props.active && props.payload) {
    const {stabilizationPayloads, selectedMetrics, selectedMonths, selectedAsinTypes} = props;
    let newPayload = [...props.payload];
    stabilizationPayloads.forEach(stabilizationPayload => {
      newPayload.push({
                        name: generateStabilizationLabel(stabilizationPayload.id, selectedMonths.length > 1,
                                                         selectedMetrics.length > 1, selectedAsinTypes.length > 1),
                        value: `${unixToFormattedDate(stabilizationPayload.stabilizationDate)} (${stabilizationPayload.stabilizationPeriod} days)`,
                      });
    })

    return <DefaultTooltipContent {...props} payload={newPayload} />;
  }

  return <DefaultTooltipContent {...props} />;
};

export default CustomTooltipContent;



// WEBPACK FOOTER //
// ./src/components/reports/asin_metrics/stabilization_custom_tooltip_content.jsx